import { all, takeLatest } from 'redux-saga/effects';
import { END_ENGAGEMENT } from '../actions';
import { endDemoEngagementWorker } from './end-demo-engagement-worker';

export default function* expoInfoWatcher() {
  yield all([takeLatest(END_ENGAGEMENT, endDemoEngagementWorker)]);
}
